import { AxiosResponse } from 'axios';
import { snakeCaseKeys } from 'helpers/utils';
import { get, post, remove } from 'services/api';
import { IMarriagesFormData } from 'views/public/MarriagesView/components/MarriagesForm/types';

export const getAll = (
  limit: number,
  page: number,
  search: string,
  sortKey: string,
  sortType: string,
): Promise<AxiosResponse> =>
  get(
    `marriages?limit=${limit}&page=${page}&search=${search}&sortKey=${sortKey}&sortType=${sortType}`,
  );

export const getForm = (): Promise<AxiosResponse> => get('marriages/form');

export const getOne = (id: string): Promise<AxiosResponse> => get(`marriages/${id}`);

export const save = (data: IMarriagesFormData, id: string): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append(
    'groom',
    JSON.stringify(snakeCaseKeys(data.groom as unknown as Record<string, unknown>)),
  );
  if (data.groom?.idCardFile) formData.append('groom_id_card_file', data.groom.idCardFile);
  if (data.groom?.idCardBackFile)
    formData.append('groom_id_card_back_file', data.groom.idCardBackFile);
  if (data.groom?.getFile) formData.append('groom_get_file', data.groom.getFile);
  if (data.groom?.parents?.father?.idCardFile)
    formData.append('groom_parents_father_id_card_file', data.groom.parents.father.idCardFile);
  if (data.groom?.parents?.father?.idCardBackFile)
    formData.append(
      'groom_parents_father_id_card_back_file',
      data.groom.parents.father.idCardBackFile,
    );
  if (data.groom?.parents?.father?.getFile)
    formData.append('groom_parents_father_get_file', data.groom.parents.father.getFile);
  if (data.groom?.parents?.mother?.idCardFile)
    formData.append('groom_parents_mother_id_card_file', data.groom.parents.mother.idCardFile);
  if (data.groom?.parents?.mother?.idCardBackFile)
    formData.append(
      'groom_parents_mother_id_card_back_file',
      data.groom.parents.mother.idCardBackFile,
    );
  if (data.groom?.parents?.mother?.getFile)
    formData.append('groom_parents_mother_get_file', data.groom.parents.mother.getFile);
  if (data.groom?.parents?.ketubaFile)
    formData.append('groom_parents_ketuba_file', data.groom.parents.ketubaFile);
  if (data.groom?.parents?.marriageCertificateFile)
    formData.append(
      'groom_parents_marriage_certificate_file',
      data.groom.parents.marriageCertificateFile,
    );
  if (data.groom?.grandParents?.paternalKetubaFile)
    formData.append(
      'groom_grand_parents_paternal_ketuba_file',
      data.groom.grandParents.paternalKetubaFile,
    );
  if (data.groom?.grandParents?.paternalMarriageCertificateFile)
    formData.append(
      'groom_grand_parents_paternal_marriage_certificate_file',
      data.groom.grandParents.paternalMarriageCertificateFile,
    );
  if (data.groom?.grandParents?.maternalKetubaFile)
    formData.append(
      'groom_grand_parents_maternal_ketuba_file',
      data.groom.grandParents.maternalKetubaFile,
    );
  if (data.groom?.grandParents?.maternalMarriageCertificateFile)
    formData.append(
      'groom_grand_parents_maternal_marriage_certificate_file',
      data.groom.grandParents.maternalMarriageCertificateFile,
    );
  data.groom?.witnesses?.forEach((witness, i) => {
    formData.append(`groom_witnesses_id_card_files[${i}]`, witness.idCardFile ?? '');
    formData.append(`groom_witnesses_id_card_back_files[${i}]`, witness.idCardBackFile ?? '');
    formData.append(`groom_witnesses_ketuba_files[${i}]`, witness.ketubaFile ?? '');
    formData.append(
      `groom_witnesses_marriage_certificate_files[${i}]`,
      witness.marriageCertificateFile ?? '',
    );
  });
  formData.append(
    'bride',
    JSON.stringify(snakeCaseKeys(data.bride as unknown as Record<string, unknown>)),
  );
  if (data.bride?.idCardFile) formData.append('bride_id_card_file', data.bride.idCardFile);
  if (data.bride?.idCardBackFile)
    formData.append('bride_id_card_back_file', data.bride.idCardBackFile);
  if (data.bride?.getFile) formData.append('bride_get_file', data.bride.getFile);
  if (data.bride?.parents?.father?.idCardFile)
    formData.append('bride_parents_father_id_card_file', data.bride.parents.father.idCardFile);
  if (data.bride?.parents?.father?.idCardBackFile)
    formData.append(
      'bride_parents_father_id_card_back_file',
      data.bride.parents.father.idCardBackFile,
    );
  if (data.bride?.parents?.father?.getFile)
    formData.append('bride_parents_father_get_file', data.bride.parents.father.getFile);
  if (data.bride?.parents?.mother?.idCardFile)
    formData.append('bride_parents_mother_id_card_file', data.bride.parents.mother.idCardFile);
  if (data.bride?.parents?.mother?.idCardBackFile)
    formData.append(
      'bride_parents_mother_id_card_back_file',
      data.bride.parents.mother.idCardBackFile,
    );
  if (data.bride?.parents?.mother?.getFile)
    formData.append('bride_parents_mother_get_file', data.bride.parents.mother.getFile);
  if (data.bride?.parents?.ketubaFile)
    formData.append('bride_parents_ketuba_file', data.bride.parents.ketubaFile);
  if (data.bride?.parents?.marriageCertificateFile)
    formData.append(
      'bride_parents_marriage_certificate_file',
      data.bride.parents.marriageCertificateFile,
    );
  if (data.bride?.grandParents?.paternalKetubaFile)
    formData.append(
      'bride_grand_parents_paternal_ketuba_file',
      data.bride.grandParents.paternalKetubaFile,
    );
  if (data.bride?.grandParents?.paternalMarriageCertificateFile)
    formData.append(
      'bride_grand_parents_paternal_marriage_certificate_file',
      data.bride.grandParents.paternalMarriageCertificateFile,
    );
  if (data.bride?.grandParents?.maternalKetubaFile)
    formData.append(
      'bride_grand_parents_maternal_ketuba_file',
      data.bride.grandParents.maternalKetubaFile,
    );
  if (data.bride?.grandParents?.maternalMarriageCertificateFile)
    formData.append(
      'bride_grand_parents_maternal_marriage_certificate_file',
      data.bride.grandParents.maternalMarriageCertificateFile,
    );
  data.bride?.witnesses?.forEach((witness, i) => {
    formData.append(`bride_witnesses_id_card_files[${i}]`, witness.idCardFile ?? '');
    formData.append(`bride_witnesses_id_card_back_files[${i}]`, witness.idCardBackFile ?? '');
    formData.append(`bride_witnesses_ketuba_files[${i}]`, witness.ketubaFile ?? '');
    formData.append(
      `bride_witnesses_marriage_certificate_files[${i}]`,
      witness.marriageCertificateFile ?? '',
    );
  });
  formData.append(
    'ceremony',
    JSON.stringify(snakeCaseKeys(data.ceremony as unknown as Record<string, unknown>)),
  );
  if (data.comments) formData.append('comments', data.comments);
  if (id) formData.append('_method', 'PUT');
  return post(`marriages${!id ? '' : `/${id}`}`, formData, { transformRequest: () => formData });
};

export const softDelete = (id: string): Promise<AxiosResponse> => remove(`marriages/${id}`);

export const softDeleteFile = (id: string, fileId: string): Promise<AxiosResponse> =>
  remove(`marriages/${id}/files/${fileId}`);
